import React from "react"
import { Link } from "react-router-dom"



const Heirloom = () => {
  return (
    <div className="relative h-screen w-screen overflow-hidden">
      {/* Background Image - hidden on mobile */}
      <img 
        src={process.env.PUBLIC_URL + "/heirloom.jpg"} 
        alt="Heirloom Background" 
        className="absolute top-0 right-0 w-[60%] h-full object-cover hidden md:block"
      />
      
      {/* Content Section - full width on mobile */}
      <div className="absolute top-0 left-0 w-full md:w-[45%] h-full bg-accent flex flex-col justify-center px-6 md:px-12 md:pt-0">
        <div className="-mt-16">
        <h1 className="text-4xl md:text-5xl font-serif text-white mb-8">
          CREATE YOUR OWN HEIRLOOM PIECE
        </h1>

        
        <p className="text-lg md:text-xl text-white mb-4">
          What symbolism, mythological character or emperor would you like on your ancient coin talisman?
        </p>
        
        <p className="text-lg md:text-xl text-white mb-4">
          What meaning would you like it to carry for you?
        </p>
        
        <p className="text-lg md:text-xl text-white mb-8">
          It all begins with a message to Keira who will help source the perfect coin within your budget. Ancient coins can range in value from $50 to $500,000 and more! There is truly something for everyone out there.
        </p>
        </div>
        

        <Link 
          to="/contact" 
          className="flex items-center justify-between bg-transparent border-2 border-white text-white px-6 md:px-8 py-3 rounded-full hover:bg-white hover:bg-opacity-10 transition-all duration-300 w-[90%] md:w-[80%] max-w-[400px]"
        >
          <span className="text-lg md:text-xl tracking-widest font-light">
            It all starts here!
          </span>
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-6 w-12" 
            fill="none" 
            viewBox="0 0 36 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M34 12h-28 M12 4l-8 8 8 8" 
            />
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default Heirloom;

